import React from "react";
import { Box, MainCard, MainText } from "app/components/common";
import theme from "app/Theme/Theme";
import PadlockIcon from "app/components/Icons/PadlockIcon";
import moment from "moment";
import normalize from "app/utils/normalize";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";

interface IProps {
  iconBox: React.ReactElement;
  date: string;
  title: string;
  isLocked?: boolean;
}

export const LockedTimelineCard = ({
  iconBox,
  date,
  title,
  isLocked = true,
}: IProps) => {
  const language = useSelector(getLanguage);
  return (
    <MainCard
      variant="timelineCard"
      flexDirection="row"
      backgroundColor="neutral.white"
      borderWidth={1}
      borderColor="neutral.100"
      padding="sm"
    >
      {iconBox}
      <Box
        flex={1}
        marginLeft={{ phone: "xm", smallWeb: "sl" }}
        marginRight={{ phone: "xm", smallWeb: "sl" }}
      >
        <MainText variant="l4-bold" color="neutral.600">
          {moment(new Date(date)).locale(language).format("dddd D MMMM")}
        </MainText>
        <MainText
          marginTop={2}
          variant="l3-medium"
          color="neutral.600"
          numberOfLines={1}
        >
          {title}
        </MainText>
      </Box>
      <PadlockIcon
        height={normalize(18)}
        width={normalize(18)}
        color={theme.colors["neutral.600"]}
      />
    </MainCard>
  );
};
